import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Titulo from "../../../atoms/titles/Titulo";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import { getPDF } from "../../../services/NominasService";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";

const VerNominaPDF = () => {
  const navigate = useNavigate();

  const [datosNominaSelect, setDatosNominaSelect] = useState(null);
  const stored = localStorage.getItem("datosNominaSelect");
  useEffect(() => {
    if (stored) setDatosNominaSelect(JSON.parse(stored));
  }, [stored]);


  const [file, setFile] = useState(null);
  const [solicitud, setSolicitud] = useState(null);
  const [loading, setLoading] = useState(false);

  const obtenerMesEnTexto = (nombreMes, mes, año) => {
    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    if (mes < 1 || mes > 14) return "Mes inválido"; //Considerando 13 y 14 como anticipos que puede o no que esten
    return !meses.includes(nombreMes.toUpperCase()) ? `${nombreMes}` : `${nombreMes}  ${año}`;
  };

  useEffect(() => {
    if (!datosNominaSelect) return;

    getPDF(datosNominaSelect?.anyo, datosNominaSelect?.mes).then((data) => {
      setFile(data);

      if (data?.type === 'application/pdf') {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          setSolicitud(reader.result);
          setLoading(true);
        };
      } else {
        // Podrías manejar aquí errores si no es un PDF válido
        setLoading(true);
      }
    });
  }, [datosNominaSelect]);

  return (
    <>
      <Header />
      <div className="container-fluid">
        {loading ? (
          <div className="datosPersonalesCarrera d-flex flex-column m-2">
            <div>
              <div className="d-flex justify-content-between">
                <Titulo
                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                  tipo={"tituloCard noBg"}
                  titulo={`Nómina - ${obtenerMesEnTexto(datosNominaSelect?.nombreMes, datosNominaSelect.mes, datosNominaSelect.anyo)}`}
                />
              </div>
              <div className="separador"></div>
            </div>

            <div className="formulario">
              <div className="m-2"></div>
              <div className="m-3 card scroll-list container-list-border">
                <div className="gridPresentar">
                  <div className="iframePresentar pt-3">
                    {solicitud && file?.size !== 0 ? (
                      <object
                        data={solicitud}
                        type="application/pdf"
                        height="500"
                        width="100%"
                        className="rounded"
                        aria-label="PDF del borrador"
                        name="sol"
                      />
                    ) : (
                      <p style={{ height: "500px", width: "100%" }}>
                        No se ha encontrado el documento en el sistema.
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="gridBotones mb-2">
                <button
                  id="volver"
                  className="btnRed rounded btnCancelarDocumentacion"
                  type="button"
                  onClick={() => {
                    localStorage.removeItem("datosNominaSelect");
                    navigate("/home");
                  }}
                >
                  <i className="fa-solid fa-rotate-left"></i> Volver
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className=""><SpinnerCircle /></div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default VerNominaPDF;
